/* GT Calculator — Professor Monstera — Shopify Asset v6
   Continue buttons are ALWAYS enabled — validation happens inside gtcGo (shake if nothing selected)
   This avoids all disabled-button click-event issues in Shopify */

(function () {
  'use strict';

  function injectCSS() {
    if (document.getElementById('gtCalcCSS')) return;
    var s = document.createElement('style');
    s.id = 'gtCalcCSS';
    s.textContent = [
      '@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap");',
      '@keyframes gtcShake{0%,100%{transform:translateX(0)}20%{transform:translateX(-8px)}40%{transform:translateX(8px)}60%{transform:translateX(-5px)}80%{transform:translateX(5px)}}',
      '#pmCalcInner{font-family:"Plus Jakarta Sans",sans-serif;color:#1a2e1e;background:#f7f9f7;pointer-events:auto;}',
      '#pmCalcInner *{box-sizing:border-box;margin:0;padding:0;}',
      '#pmCalcInner a{text-decoration:none;}',
      '#pmCalcInner .gtc-hdr{background:#fff;border-bottom:1px solid #ddeee2;padding:18px 16px 14px;text-align:center;}',
      '#pmCalcInner .gtc-pill{display:inline-block;background:#e8f8ee;color:#00a846;font-size:10px;font-weight:700;letter-spacing:2px;text-transform:uppercase;padding:4px 12px;border-radius:20px;margin-bottom:8px;}',
      '#pmCalcInner .gtc-h1{font-size:clamp(17px,4vw,24px);font-weight:800;line-height:1.2;color:#1a2e1e;margin-bottom:4px;}',
      '#pmCalcInner .gtc-h1 span{color:#00a846;}',
      '#pmCalcInner .gtc-hsub{font-size:12px;color:#4a6650;}',
      '#pmCalcInner .gtc-prog{background:#fff;border-bottom:1px solid #ddeee2;padding:0 4px;display:flex;overflow-x:auto;}',
      '#pmCalcInner .gtc-step{display:flex;align-items:center;gap:4px;padding:10px 6px;font-size:10px;font-weight:600;color:#8aa890;border-bottom:3px solid transparent;white-space:nowrap;flex-shrink:0;cursor:default;}',
      '#pmCalcInner .gtc-step.active{color:#00a846;border-bottom-color:#00a846;}',
      '#pmCalcInner .gtc-step.done{color:#4a6650;border-bottom-color:#b8eeca;}',
      '#pmCalcInner .gtc-num{width:17px;height:17px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;background:#f7f9f7;border:1.5px solid #ddeee2;}',
      '#pmCalcInner .gtc-step.active .gtc-num{background:#00a846;border-color:#00a846;color:#fff;}',
      '#pmCalcInner .gtc-step.done .gtc-num{background:#e8f8ee;border-color:#b8eeca;color:#00a846;}',
      '#pmCalcInner .gtc-main{padding:20px 14px 60px;}',
      '#pmCalcInner .gtc-sec{display:none;}',
      '#pmCalcInner .gtc-sec.active{display:block;}',
      '#pmCalcInner .gtc-qlbl{font-size:10px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#00a846;margin-bottom:5px;}',
      '#pmCalcInner .gtc-qtitle{font-size:clamp(16px,4vw,22px);font-weight:800;line-height:1.2;color:#1a2e1e;margin-bottom:4px;}',
      '#pmCalcInner .gtc-qsub{font-size:12px;color:#4a6650;margin-bottom:18px;line-height:1.6;}',
      '#pmCalcInner .gtc-opts{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:8px;margin-bottom:18px;}',
      '#pmCalcInner .gtc-opts.two{grid-template-columns:repeat(2,1fr);}',
      '#pmCalcInner .gtc-opts.three{grid-template-columns:repeat(3,1fr);}',
      '#pmCalcInner .gtc-opt{background:#fff;border:2px solid #ddeee2;border-radius:10px;padding:12px 10px;cursor:pointer;transition:all .2s;position:relative;user-select:none;}',
      '#pmCalcInner .gtc-opt:hover{border-color:#b8eeca;box-shadow:0 3px 12px rgba(0,100,40,.1);transform:translateY(-1px);}',
      '#pmCalcInner .gtc-opt.selected{border-color:#00a846;background:#e8f8ee;}',
      '#pmCalcInner .gtc-opt.selected::after{content:"\\2713";position:absolute;top:7px;right:9px;width:16px;height:16px;background:#00a846;color:#fff;border-radius:50%;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;}',
      '#pmCalcInner .gtc-oicon{font-size:22px;margin-bottom:6px;display:block;}',
      '#pmCalcInner .gtc-otitle{font-size:12px;font-weight:700;color:#1a2e1e;margin-bottom:2px;}',
      '#pmCalcInner .gtc-odesc{font-size:10px;color:#4a6650;line-height:1.4;}',
      '#pmCalcInner .gtc-oprice{font-size:14px;font-weight:800;color:#00a846;margin-top:6px;}',
      '#pmCalcInner .gtc-toggle{display:flex;gap:8px;margin-bottom:18px;}',
      '#pmCalcInner .gtc-tog{flex:1;padding:12px;background:#fff;border:2px solid #ddeee2;border-radius:10px;cursor:pointer;font-size:13px;font-weight:700;text-align:center;color:#4a6650;transition:all .2s;}',
      '#pmCalcInner .gtc-tog:hover{transform:translateY(-1px);box-shadow:0 3px 10px rgba(0,100,40,.1);}',
      '#pmCalcInner .gtc-tog.yes.on{border-color:#00a846;background:#e8f8ee;color:#00a846;}',
      '#pmCalcInner .gtc-tog.no.on{border-color:#ff4757;background:#fff0f1;color:#ff4757;}',
      '#pmCalcInner .gtc-alert{background:#fff3b0;border:1.5px solid #ffd600;border-radius:9px;padding:11px 13px;margin-bottom:16px;font-size:11px;color:#6b5800;line-height:1.6;display:flex;gap:7px;}',
      '#pmCalcInner .gtc-media-box{background:#fff;border:1.5px solid #ddeee2;border-radius:10px;padding:12px 14px;margin-bottom:16px;}',
      '#pmCalcInner .gtc-media-lbl{font-size:9px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#8aa890;margin-bottom:8px;}',
      '#pmCalcInner .gtc-mbtn{display:inline-flex;align-items:center;gap:5px;padding:6px 10px;margin:0 5px 5px 0;background:#f7f9f7;border:1.5px solid #ddeee2;border-radius:6px;font-size:11px;font-weight:600;color:#4a6650;cursor:pointer;transition:all .2s;}',
      '#pmCalcInner .gtc-mbtn.on{border-color:#00a846;background:#e8f8ee;color:#00a846;}',
      /* ── Continue button: always enabled, always green ── */
      '#pmCalcInner .gtc-next{background:#00a846;color:#fff;font-size:13px;font-weight:700;padding:12px 28px;border-radius:8px;border:none;cursor:pointer;box-shadow:0 4px 0 #007a30;width:100%;margin-top:4px;display:block;}',
      '#pmCalcInner .gtc-next:hover{transform:translateY(2px);box-shadow:0 2px 0 #007a30;}',
      '#pmCalcInner .gtc-rhero{background:#fff;border-radius:12px;padding:18px 14px 14px;margin-bottom:18px;border:1.5px solid #ddeee2;text-align:center;}',
      '#pmCalcInner .gtc-rhero h2{font-size:20px;font-weight:800;color:#1a2e1e;margin-bottom:3px;}',
      '#pmCalcInner .gtc-rhero p{font-size:11px;color:#4a6650;}',
      '#pmCalcInner .gtc-rsec{margin-bottom:18px;}',
      '#pmCalcInner .gtc-rslbl{font-size:9px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#8aa890;margin-bottom:7px;padding-bottom:4px;border-bottom:1px solid #ddeee2;}',
      '#pmCalcInner .gtc-pc{background:#fff;border:1.5px solid #ddeee2;border-radius:9px;padding:11px 12px;margin-bottom:5px;display:flex;align-items:flex-start;gap:9px;}',
      '#pmCalcInner .gtc-pc.ess{border-left:4px solid #00a846;}',
      '#pmCalcInner .gtc-pc.phc{border-left:4px solid #ffd600;background:#fffef0;}',
      '#pmCalcInner .gtc-pem{font-size:18px;flex-shrink:0;margin-top:1px;}',
      '#pmCalcInner .gtc-pi{flex:1;min-width:0;}',
      '#pmCalcInner .gtc-pn{font-size:12px;font-weight:700;color:#1a2e1e;margin-bottom:2px;}',
      '#pmCalcInner .gtc-pw{font-size:10px;color:#4a6650;line-height:1.4;}',
      '#pmCalcInner .gtc-pr{font-size:14px;font-weight:800;color:#00a846;flex-shrink:0;white-space:nowrap;}',
      '#pmCalcInner .gtc-bdg{font-size:8px;font-weight:700;letter-spacing:1px;text-transform:uppercase;padding:2px 5px;border-radius:3px;flex-shrink:0;}',
      '#pmCalcInner .gtc-bdg.essential{background:#e8f8ee;color:#00a846;}',
      '#pmCalcInner .gtc-bdg.ph{background:#fff3b0;color:#8b6900;}',
      '#pmCalcInner .gtc-bdg.optional{background:#f7f9f7;color:#8aa890;}',
      '#pmCalcInner .gtc-atc{background:#00a846;color:#fff;border:none;border-radius:5px;padding:4px 9px;font-size:9px;font-weight:700;cursor:pointer;white-space:nowrap;margin-top:4px;}',
      '#pmCalcInner .gtc-atc.done{background:#007a30;}',
      '#pmCalcInner .gtc-tots{background:#fff;border:2px solid #00a846;border-radius:12px;padding:16px 14px;margin:18px 0;}',
      '#pmCalcInner .gtc-tr{display:flex;justify-content:space-between;align-items:center;padding:5px 0;font-size:12px;color:#4a6650;border-bottom:1px solid #ddeee2;}',
      '#pmCalcInner .gtc-tr:last-child{border:none;}',
      '#pmCalcInner .gtc-tr.save{color:#00a846;font-weight:600;}',
      '#pmCalcInner .gtc-tr.grand{font-size:18px;font-weight:800;color:#1a2e1e;padding-top:9px;border:none;}',
      '#pmCalcInner .gtc-tr.grand .v{color:#00a846;}',
      '#pmCalcInner .gtc-rb{background:linear-gradient(135deg,#e8f8ee,#f0faf3);border:2px solid #b8eeca;border-radius:12px;padding:14px;display:flex;align-items:center;gap:10px;margin:14px 0;}',
      '#pmCalcInner .gtc-rbi{font-size:28px;flex-shrink:0;}',
      '#pmCalcInner .gtc-rbb h3{font-size:13px;font-weight:800;color:#1a2e1e;margin-bottom:2px;}',
      '#pmCalcInner .gtc-rbb p{font-size:10px;color:#4a6650;line-height:1.4;}',
      '#pmCalcInner .gtc-ctas{display:flex;gap:8px;flex-wrap:wrap;justify-content:center;margin:16px 0;}',
      '#pmCalcInner .gtc-btn{background:#00a846;color:#fff;font-size:12px;font-weight:700;padding:11px 20px;border-radius:8px;display:inline-block;box-shadow:0 4px 0 #007a30;cursor:pointer;}',
      '#pmCalcInner .gtc-btn:hover{transform:translateY(2px);box-shadow:0 2px 0 #007a30;color:#fff;}',
      '#pmCalcInner .gtc-ghost{background:transparent;color:#4a6650;font-size:12px;font-weight:600;padding:11px 18px;border-radius:8px;border:1.5px solid #ddeee2;cursor:pointer;}',
      '#pmCalcInner .gtc-ghost:hover{border-color:#4a6650;color:#1a2e1e;}',
      '#pmCalcInner .gtc-addall{background:#1a3a1a;color:#ffe000;font-size:14px;font-weight:800;letter-spacing:1px;padding:13px 28px;border-radius:9px;border:3px solid #0d2010;box-shadow:4px 4px 0 #0d2010;cursor:pointer;width:100%;max-width:340px;}',
      '#pmCalcInner .gtc-hint{font-size:11px;color:#ff4757;margin-bottom:8px;display:none;}',
      '#pmCalcInner .gtc-hint.show{display:block;}',
      /* Override Shopify theme rule: .gtc-step{position:absolute;inset:24px;opacity:0} */
      '#pmCalcInner .gtc-prog .gtc-step{position:relative !important;inset:auto !important;opacity:1 !important;height:auto !important;width:auto !important;display:flex !important;}',
      '@media(max-width:400px){#pmCalcInner .gtc-opts.three{grid-template-columns:repeat(2,1fr);}#pmCalcInner .gtc-opts.two{grid-template-columns:1fr;}}',
    ].join('');
    document.head.appendChild(s);
  }

  /* ── HTML: NO disabled attribute on any button ── */
  var CALC_HTML = ''
    + '<div class="gtc-hdr">'
    +   '<div class="gtc-pill">🌿 Growth Technology · Professor Monstera</div>'
    +   '<h2 class="gtc-h1">Build Your <span>Perfect GT Kit</span></h2>'
    +   '<p class="gtc-hsub">5 quick questions — we\'ll show you exactly what you need.</p>'
    + '</div>'
    + '<div class="gtc-prog">'
    +   '<div class="gtc-step active" id="gtcps1"><div class="gtc-num">1</div>Goal</div>'
    +   '<div class="gtc-step" id="gtcps2"><div class="gtc-num">2</div>Method</div>'
    +   '<div class="gtc-step" id="gtcps3"><div class="gtc-num">3</div>Plants</div>'
    +   '<div class="gtc-step" id="gtcps4"><div class="gtc-num">4</div>Silica</div>'
    +   '<div class="gtc-step" id="gtcps5"><div class="gtc-num">5</div>pH</div>'
    +   '<div class="gtc-step" id="gtcps6"><div class="gtc-num">6</div>Kit</div>'
    + '</div>'
    + '<div class="gtc-main">'

    + '<div class="gtc-sec active" id="gtcs1">'
    +   '<div class="gtc-qlbl">Step 1 of 5</div>'
    +   '<div class="gtc-qtitle">What do you want to do?</div>'
    +   '<div class="gtc-qsub">We\'ll build your kit around this.</div>'
    +   '<p class="gtc-hint" id="gtc-hint1">Please select an option above</p>'
    +   '<div class="gtc-opts three" id="gtc-opts1">'
    +     '<div class="gtc-opt" data-key="goal" data-val="grow"><span class="gtc-oicon">🌿</span><div class="gtc-otitle">Grow &amp; Feed</div><div class="gtc-odesc">Keep plants healthy and growing strong</div></div>'
    +     '<div class="gtc-opt" data-key="goal" data-val="propagate"><span class="gtc-oicon">✂️</span><div class="gtc-otitle">Propagate</div><div class="gtc-odesc">Take cuttings and build your collection</div></div>'
    +     '<div class="gtc-opt" data-key="goal" data-val="both"><span class="gtc-oicon">🚀</span><div class="gtc-otitle">Both</div><div class="gtc-odesc">Growing plants and taking cuttings</div></div>'
    +   '</div>'
    +   '<button class="gtc-next" id="gtcn1">Continue →</button>'
    + '</div>'

    + '<div class="gtc-sec" id="gtcs2">'
    +   '<div class="gtc-qlbl">Step 2 of 5</div>'
    +   '<div class="gtc-qtitle">How do you grow?</div>'
    +   '<div class="gtc-qsub">Each method needs slightly different products.</div>'
    +   '<p class="gtc-hint" id="gtc-hint2">Please select an option above</p>'
    +   '<div class="gtc-opts three" id="gtc-opts2">'
    +     '<div class="gtc-opt" data-key="method" data-val="soil"><span class="gtc-oicon">🪱</span><div class="gtc-otitle">Soil</div><div class="gtc-odesc">Standard potting mix or living soil</div></div>'
    +     '<div class="gtc-opt" data-key="method" data-val="coco"><span class="gtc-oicon">🥥</span><div class="gtc-otitle">Coco</div><div class="gtc-odesc">Coco coir &amp; perlite mix</div></div>'
    +     '<div class="gtc-opt" data-key="method" data-val="leca"><span class="gtc-oicon">💧</span><div class="gtc-otitle">LECA / Semi-Hydro</div><div class="gtc-odesc">Clay balls, passive hydro</div></div>'
    +   '</div>'
    +   '<div id="gtc-media-wrap" style="display:none"><div class="gtc-media-box"><div class="gtc-media-lbl">Add growing media?</div><div id="gtc-media-btns"></div></div></div>'
    +   '<button class="gtc-next" id="gtcn2">Continue →</button>'
    + '</div>'

    + '<div class="gtc-sec" id="gtcs3">'
    +   '<div class="gtc-qlbl">Step 3 of 5</div>'
    +   '<div class="gtc-qtitle">What are you growing?</div>'
    +   '<div class="gtc-qsub">We\'ll match the right GT Focus nutrient for your plants.</div>'
    +   '<p class="gtc-hint" id="gtc-hint3">Please select an option above</p>'
    +   '<div class="gtc-opts" id="gtc-plant-opts"></div>'
    +   '<button class="gtc-next" id="gtcn3">Continue →</button>'
    + '</div>'

    + '<div class="gtc-sec" id="gtcs4">'
    +   '<div class="gtc-qlbl">Step 4 of 5</div>'
    +   '<div class="gtc-qtitle">Add GT Silica?</div>'
    +   '<div class="gtc-qsub">Strengthens leaves, stops brown tips, increases pest resistance.</div>'
    +   '<div class="gtc-alert"><span style="font-size:15px;flex-shrink:0">⚠️</span><span><strong>Heads up:</strong> GT Silica raises pH. You\'ll need to adjust it or your plant can\'t absorb nutrients — we\'ll sort that next.</span></div>'
    +   '<p class="gtc-hint" id="gtc-hint4">Please make a selection above</p>'
    +   '<div class="gtc-toggle">'
    +     '<button class="gtc-tog yes" data-key="silica" data-val="yes">✅ Yes — protect my leaves</button>'
    +     '<button class="gtc-tog no" data-key="silica" data-val="no">✗ Not right now</button>'
    +   '</div>'
    +   '<button class="gtc-next" id="gtcn4">Continue →</button>'
    + '</div>'

    + '<div class="gtc-sec" id="gtcs5">'
    +   '<div class="gtc-qlbl">Step 5 of 5</div>'
    +   '<div class="gtc-qtitle" id="gtc-ph-title">pH Management</div>'
    +   '<div class="gtc-qsub" id="gtc-ph-sub"></div>'
    +   '<p class="gtc-hint" id="gtc-hint5">Please select an option above</p>'
    +   '<div id="gtc-ph-req" style="display:none">'
    +     '<div class="gtc-opts two">'
    +       '<div class="gtc-opt" data-key="ph" data-val="budget"><span class="gtc-oicon">⚗️</span><div class="gtc-otitle">Hy-Gen Starter Kit</div><div class="gtc-odesc">pH Up + Down + indicator.</div><div class="gtc-oprice">$34.81</div></div>'
    +       '<div class="gtc-opt" data-key="ph" data-val="digital"><span class="gtc-oicon">🟡</span><div class="gtc-otitle">Yellow pH Pen</div><div class="gtc-odesc">Digital pen + pH Up + Down.</div><div class="gtc-oprice">$87.05</div></div>'
    +     '</div>'
    +   '</div>'
    +   '<div id="gtc-ph-opt" style="display:none">'
    +     '<div class="gtc-opts three">'
    +       '<div class="gtc-opt" data-key="ph" data-val="none"><span class="gtc-oicon">👍</span><div class="gtc-otitle">Skip — soil is fine</div><div class="gtc-odesc">Soil buffers pH naturally.</div></div>'
    +       '<div class="gtc-opt" data-key="ph" data-val="budget"><span class="gtc-oicon">⚗️</span><div class="gtc-otitle">Hy-Gen Starter Kit</div><div class="gtc-odesc">Good to have. $34.81</div></div>'
    +       '<div class="gtc-opt" data-key="ph" data-val="digital"><span class="gtc-oicon">🟡</span><div class="gtc-otitle">Yellow pH Pen</div><div class="gtc-odesc">More accurate. $87.05</div></div>'
    +     '</div>'
    +   '</div>'
    +   '<button class="gtc-next" id="gtcn5">See My Kit →</button>'
    + '</div>'

    + '<div class="gtc-sec" id="gtcs6"><div id="gtc-results"></div></div>'
    + '</div>'; /* end gtc-main */

  function bindAll(c) {
    /* ── Option cards (static: steps 1,2,4,5) ── */
    c.querySelectorAll('.gtc-opt[data-key]').forEach(function (o) {
      o.addEventListener('click', function () { gtcPick(o); });
    });
    /* ── Silica toggles ── */
    c.querySelectorAll('.gtc-tog[data-key]').forEach(function (t) {
      t.addEventListener('click', function () { gtcTog(t); });
    });
    /* ── Next buttons 1–4 (direct listeners, NO disabled) ── */
    [1,2,3,4].forEach(function (n) {
      var btn = document.getElementById('gtcn' + n);
      if (btn) btn.addEventListener('click', function () { gtcGo(n); });
    });
    /* ── Results button ── */
    var n5 = document.getElementById('gtcn5');
    if (n5) n5.addEventListener('click', function () { gtcShowResults(); });
    /* ── Delegation: dynamic + results page elements ── */
    c.addEventListener('click', function (e) {
      var pOpt = e.target.closest('#gtc-plant-opts .gtc-opt');
      if (pOpt) { gtcPick(pOpt); return; }
      var mBtn = e.target.closest('#gtc-media-btns .gtc-mbtn');
      if (mBtn) { gtcToggleMedia(mBtn); return; }
      var atc = e.target.closest('.gtc-atc[data-handle]');
      if (atc && !atc.disabled) { gtcAddToCart(atc.dataset.handle, atc); return; }
      var addAll = e.target.closest('#gtc-add-all');
      if (addAll && !addAll.disabled) {
        if (addAll.dataset.cart) { window.location.href = '/cart'; return; }
        gtcAddAll(JSON.parse(addAll.dataset.keys)); return;
      }
      var rst = e.target.closest('.gtc-ghost[data-reset]');
      if (rst) { gtcReset(); return; }
    });
  }

  function inject() {
    var t = document.getElementById('pmCalcInner');
    if (!t) { setTimeout(inject, 150); return; }
    injectCSS();
    t.innerHTML = CALC_HTML;
    t.style.pointerEvents = 'auto';
    bindAll(t);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();

/* ═══ STATE + LOGIC ═══ */

var GTC = { goal:null, method:null, plant:null, silica:null, ph:null, media:[] };
var gtcCur = 1;

var GTC_P = {
  foliage_focus:   { n:'GT Foliage Focus 1L',                p:19.95, e:'🌿', w:'Complete nutrition for foliage plants — the Brown Formula base',              b:'essential', h:'foliage-focus' },
  flower_focus:    { n:'GT Flower Focus 1L',                 p:11.95, e:'🌸', w:'For flowering and fruiting stage',                                             b:'essential', h:'flower-focus' },
  fruit_focus:     { n:'GT Fruit Focus 1L',                  p:11.95, e:'🍋', w:'Maximise fruit development and flavour',                                       b:'essential', h:'fruit-focus' },
  orchid_focus:    { n:'GT Orchid Focus General',            p:11.95, e:'🌺', w:'Balanced nutrition formulated for orchids',                                    b:'essential', h:'orchid-focus-grow' },
  veg_focus:       { n:'GT Vegetable Focus 1L',              p:11.95, e:'🥦', w:'Higher nitrogen for leafy vegetables',                                         b:'essential', h:'vegetable-focus' },
  herb_focus:      { n:'GT Herb Focus 1L',                   p:19.95, e:'🌱', w:'Keeps herbs productive and flavourful',                                        b:'essential', h:'herb-focus' },
  succulent_focus: { n:'GT Succulent Focus',                 p:11.95, e:'🌵', w:'Low-nitrogen formula for succulents and cacti',                                b:'essential', h:'succulent-focus' },
  native_focus:    { n:'GT Australian Native Focus',         p:11.95, e:'🦘', w:'Low phosphorus — essential for Australian natives',                            b:'essential', h:'australian-native-focus' },
  coco_grow:       { n:'GT Coco Grow A&B',                   p:45.95, e:'🥥', w:'2-part system designed specifically for coco',                                 b:'essential', h:'gt-coco-grow-a-b' },
  rootzone:        { n:'GT Rootzone Biostimulant',           p:27.95, e:'🦠', w:'Root stimulant — use with Clonex when propagating or transplanting',           b:'essential', h:'gt-rootzone-biostimulant' },
  clonex_gel:      { n:'Clonex Green Rooting Gel',           p:28.60, e:'🧪', w:'Dip every cutting before it goes into media. Seals the cut, delivers rooting hormones, protects against infection.', b:'essential', h:'clonex-green' },
  clonex_css:      { n:'Clonex Clone Solution (CSS)',        p:19.95, e:'💧', w:'Feed cuttings through their leaves while they root. Mix 5ml/L, mist every 2-3 days.', b:'essential', h:'clonex-clone-solution' },
  ap_twin:         { n:'Infinity Twin Air Pump',             p:44.00, e:'💨', w:'Twin outlet air pump — keeps propagation water oxygenated 24/7.',              b:'optional',  h:'infinity-ap-750-air-pump-twin-2-x-200lh-with-airline-kit' },
  airline:         { n:'Airline Tubing Clear 5m Roll',       p:5.06,  e:'🔧', w:'Connects pump to airstones. Cut to length.',                                   b:'optional',  h:'airline-tubing-clear-five-metre-roll' },
  golf_ball_x2:    { n:'Aqua-One Golf Ball Airstone (x2)',   p:19.80, e:'⚪', w:'Two airstones — maximum oxygen diffusion into your water.',                    b:'optional',  h:'aqua-one-golf-ball-air-stone-50mm-diameter' },
  cultiv8_hygro:   { n:'Cultiv8 Thermo/Hygro + Water Probe', p:27.50, e:'🌡️',w:'Monitors air temp, humidity AND water temp via probe. Roots need 22-26°C.',   b:'essential', h:'thermometer-hygrometer-clock-in-outdoor-cultiv8' },
  scalpel:         { n:'Disposable Surgical Scalpels (x10)', p:22.00, e:'🔪', w:'Surgical-grade blades. Clean precise cuts = better strike rate.',              b:'essential', h:'scalpels-disposable-stainless-steel-carton-of-10' },
  loupe_40x:       { n:'Active Eye LED Loupe 40x',           p:28.60, e:'🔍', w:'Check root development and spot pests or mould early. LED lit.',               b:'optional',  h:'active-eye-led-illuminated-magnifier-loupe-40x' },
  seahawk_cloner:  { n:'Sea-Hawk Aero Cloner',               p:120.00,e:'🚀', w:'Aeroponic cloner — mists roots 24/7. Fastest strike rates. Set and forget.',   b:'optional',  h:'cloning-station-24-cutting-spaces-seahawk' },
  prop_tray:       { n:'Heat N Grow Propagation Set',        p:39.44, e:'🌡️',w:'3-part propagator — humidity dome, lattice tray, catchment.',                  b:'optional',  h:'heat-n-grow-propagation-set-3-part-lid-lattice-catchment' },
  speedgrow_cubes: { n:'Speedgrow Rockwool Cubes 40mm',      p:0.44,  e:'🧱', w:'Classic cube. Insert cutting, keep moist. Roots in 7-14 days.',               b:'optional',  h:'speedgrow-40-x-40-x-40mm-propagation-cubes' },
  eazy_plug_tray:  { n:'Eazy Plug CT-24 Tray',               p:16.50, e:'🔺', w:'24 organic plugs. Self-regulating — impossible to overwater.',                 b:'optional',  h:'eazy-plug-ct-24-tray' },
  coco_plugs:      { n:'Coco Plugs 36mm — Tray of 50',       p:9.90,  e:'🥥', w:'Pre-formed coco plugs. Straight into final pot when roots appear.',            b:'optional',  h:'coco-plugs-36mm-tray-of-50-cells' },
  azos:            { n:'AZOS Nitrogen Fixing Bacteria',      p:52.00, e:'🧬', w:'Explosive root growth — the backbone of the Brown Formula.',                   b:'essential', h:'azos-nitrogen-fixing-bacteria' },
  mykos:           { n:'Mykos Granular Mycorrhizal',         p:11.00, e:'🍄', w:'Colonises roots and multiplies nutrient absorption.',                          b:'essential', h:'mykos-granular-mycorrhizal-inoculant' },
  silica:          { n:'GT Silica',                          p:19.95, e:'🛡️',w:'Thickens cell walls, stops brown leaf tips, increases pest resistance.',        b:'essential', h:'gt-silica' },
  calmag:          { n:'GT Liquid CalMag',                   p:12.95, e:'💊', w:'Calcium-magnesium-nitrogen — essential for coco and LECA growers.',            b:'essential', h:'canna-calmag' },
  ph_kit:          { n:'Hy-Gen Complete pH Kit',             p:34.81, e:'⚗️', w:'pH Up + pH Down + indicator — everything to test and adjust pH.',              b:'ph',        h:'hy-gen-complete-ph-control-kit-includes-150mls-up-down' },
  ph_pen_bundle:   { n:'Yellow pH Pen + pH Up + pH Down',    p:87.05, e:'🟡', w:'Digital pH pen bundle — accurate readings, dead easy to use.',                 b:'ph',        h:'yellow-ph-pen' },
  coco_bag:        { n:'Canna Coco Professional Plus 50L',   p:49.50, e:'🥥', w:'Best buffered coco on the market.',                                            b:'optional',  h:'canna-coco-professional-plus-50-litre-bag' },
  perlite_20:      { n:'Perlite 20L Grow Bag',               p:22.00, e:'⚪', w:'Mix 30% perlite with coco for perfect drainage.',                              b:'optional',  h:null },
  leca_50:         { n:'Colossal LECA 50L',                  p:82.50, e:'🪨', w:'Premium expanded clay for semi-hydro setups.',                                 b:'optional',  h:'colossal-leca-50-litre' },
  living_soil:     { n:'Easy As Organics Living Soil 25L',   p:60.50, e:'🌍', w:'Water-only living soil — just add water, nothing else needed.',                b:'optional',  h:'easy-as-organics-water-only-soil-25-litre' },
};

var GTC_PLANTS = [
  { v:'monstera', l:'Monstera / Aroid',    i:'🌿', f:'foliage_focus', d:'Monsteras, Philodendrons, Alocasias' },
  { v:'orchid',   l:'Orchid',              i:'🌺', f:'orchid_focus',  d:'Phals, Dendrobiums, all orchids' },
  { v:'veg',      l:'Vegetables',          i:'🥦', f:'veg_focus',     d:'Tomatoes, cucumbers, leafy greens' },
  { v:'herb',     l:'Herbs',               i:'🌱', f:'herb_focus',    d:'Basil, mint, coriander, chilli' },
  { v:'fruit',    l:'Fruit Plants',        i:'🍋', f:'fruit_focus',   d:'Strawberries, chilli, fruiting plants' },
  { v:'flower',   l:'Flowers',             i:'🌸', f:'flower_focus',  d:'Roses, annuals, flowering plants' },
  { v:'succulent',l:'Succulent / Cactus',  i:'🌵', f:'succulent_focus', d:'Cacti, succulents' },
  { v:'native',   l:'Australian Native',   i:'🦘', f:'native_focus',  d:'Grevilleas, banksias, wattles' },
];

var GTC_MEDIA = {
  soil: [{ v:'living_soil', l:'Easy As Organics Living Soil 25L', p:'$60.50' }],
  coco: [{ v:'coco_bag', l:'Canna Coco 50L', p:'$49.50' }, { v:'perlite_20', l:'Perlite 20L', p:'$22.00' }],
  leca: [{ v:'leca_50', l:'Colossal LECA 50L', p:'$82.50' }],
};

function gtcShake(el) {
  if (!el) return;
  el.style.animation = 'none';
  el.offsetHeight; /* reflow */
  el.style.animation = 'gtcShake 0.4s ease';
}

function gtcPick(el) {
  var key = el.dataset.key;
  var val = el.dataset.val;
  el.closest('.gtc-opts').querySelectorAll('.gtc-opt').forEach(function (o) { o.classList.remove('selected'); });
  el.classList.add('selected');
  GTC[key] = val;
  /* hide any hint message */
  var hint = document.getElementById('gtc-hint' + gtcCur);
  if (hint) hint.classList.remove('show');
  if (key === 'method') gtcBuildMedia(val);
}

function gtcTog(el) {
  el.closest('.gtc-toggle').querySelectorAll('.gtc-tog').forEach(function (b) { b.classList.remove('on'); });
  el.classList.add('on');
  GTC[el.dataset.key] = el.dataset.val;
  var hint = document.getElementById('gtc-hint' + gtcCur);
  if (hint) hint.classList.remove('show');
}

function gtcToggleMedia(btn) {
  var v = btn.dataset.val;
  var i = GTC.media.indexOf(v);
  if (i === -1) { GTC.media.push(v); btn.classList.add('on'); }
  else { GTC.media.splice(i, 1); btn.classList.remove('on'); }
}

function gtcBuildMedia(method) {
  var wrap = document.getElementById('gtc-media-wrap');
  var btns = document.getElementById('gtc-media-btns');
  if (!wrap || !btns) return;
  wrap.style.display = 'block';
  btns.innerHTML = '';
  GTC.media = [];
  (GTC_MEDIA[method] || []).forEach(function (m) {
    var b = document.createElement('button');
    b.className = 'gtc-mbtn';
    b.dataset.val = m.v;
    b.innerHTML = '+ ' + m.l + ' <strong>' + m.p + '</strong>';
    btns.appendChild(b);
  });
}

function gtcBuildPlants() {
  var wrap = document.getElementById('gtc-plant-opts');
  if (!wrap) return;
  wrap.innerHTML = '';
  GTC_PLANTS.forEach(function (p) {
    var d = document.createElement('div');
    d.className = 'gtc-opt';
    d.dataset.key = 'plant';
    d.dataset.val = p.v;
    d.innerHTML = '<span class="gtc-oicon">' + p.i + '</span><div class="gtc-otitle">' + p.l + '</div><div class="gtc-odesc">' + p.d + '</div>';
    d.addEventListener('click', function () { gtcPick(d); });
    wrap.appendChild(d);
  });
}

function gtcBuildPh() {
  var hasSilica = GTC.silica === 'yes';
  var isProp    = GTC.goal === 'propagate' || GTC.goal === 'both';
  var needsPh   = hasSilica || GTC.method === 'coco' || GTC.method === 'leca' || isProp;
  var title = document.getElementById('gtc-ph-title');
  var sub   = document.getElementById('gtc-ph-sub');
  var req   = document.getElementById('gtc-ph-req');
  var opt   = document.getElementById('gtc-ph-opt');
  if (!title) return;
  if (isProp) {
    title.textContent = '💧 pH For Propagation';
    sub.innerHTML = 'pH affects whether cuttings absorb nutrients. Aim for <strong>pH 5.8–6.2</strong>:';
  } else if (hasSilica) {
    title.textContent = '⚠️ pH Adjustment Required';
    sub.textContent = 'GT Silica raises pH. You must correct this or your plant can\'t absorb nutrients.';
  } else if (needsPh) {
    title.textContent = 'pH Management';
    sub.textContent = 'Coco and LECA growers need to manage pH:';
  } else {
    title.textContent = 'pH Management (Optional)';
    sub.textContent = 'Soil buffers pH naturally. Skip or add a kit just in case.';
  }
  if (req) req.style.display = needsPh ? 'block' : 'none';
  if (opt) opt.style.display = !needsPh ? 'block' : 'none';
  /* attach listeners to newly visible pH opts */
  var container = document.getElementById('pmCalcInner');
  if (container) {
    container.querySelectorAll('#gtc-ph-req .gtc-opt, #gtc-ph-opt .gtc-opt').forEach(function (o) {
      o.addEventListener('click', function () { gtcPick(o); });
    });
  }
  /* if soil (not required), auto-enable so user can skip */
  if (!needsPh) GTC.ph = 'none';
}

/* ── Required-field map for each step ── */
var GTC_REQUIRED = { 1:'goal', 2:'method', 3:'plant', 4:'silica' };

function gtcGo(from) {
  /* validate — shake and show hint if nothing selected */
  var field = GTC_REQUIRED[from];
  if (field && !GTC[field]) {
    var optsEl = document.getElementById('gtc-opts' + from) || document.getElementById('gtc-plant-opts');
    gtcShake(optsEl);
    var hint = document.getElementById('gtc-hint' + from);
    if (hint) hint.classList.add('show');
    return;
  }

  var next = from + 1;

  /* propagate-only: skip method / plants / silica */
  if (from === 1 && GTC.goal === 'propagate') {
    next = 5;
    GTC.method = 'soil'; GTC.plant = 'monstera'; GTC.silica = 'no';
    ['gtcps2','gtcps3','gtcps4'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.className = 'gtc-step done';
    });
  }

  var fromSec  = document.getElementById('gtcs'  + from);
  var nextSec  = document.getElementById('gtcs'  + next);
  var fromStep = document.getElementById('gtcps' + from);
  var nextStep = document.getElementById('gtcps' + next);

  if (fromSec)  fromSec.classList.remove('active');
  if (nextSec)  nextSec.classList.add('active');
  if (fromStep) fromStep.className = 'gtc-step done';
  if (nextStep) nextStep.className = 'gtc-step active';

  gtcCur = next;
  if (gtcCur === 3) gtcBuildPlants();
  if (gtcCur === 5) gtcBuildPh();

  var panel = document.getElementById('pmCalcInner');
  if (panel) panel.scrollTop = 0;
}

function gtcPCard(key, ess) {
  var p = GTC_P[key]; if (!p) return '';
  var cls = ess ? 'gtc-pc ess' : 'gtc-pc';
  var bdg = ess ? 'essential' : 'optional';
  var atc = p.h ? '<button class="gtc-atc" data-handle="' + p.h + '">+ Add to Cart</button>' : '';
  return '<div class="' + cls + '"><div class="gtc-pem">' + p.e + '</div>'
    + '<div class="gtc-pi"><div class="gtc-pn">' + p.n + '</div><div class="gtc-pw">' + p.w + '</div>' + atc + '</div>'
    + '<div class="gtc-pr">$' + p.p.toFixed(2) + '</div>'
    + '<span class="gtc-bdg ' + bdg + '">' + bdg.toUpperCase() + '</span></div>';
}

function gtcBuildPropSection() {
  return '<div class="gtc-rsec"><div class="gtc-rslbl">✂️ The 3 Things You Need To Propagate</div>'
    + gtcPCard('clonex_gel',true) + gtcPCard('rootzone',true) + gtcPCard('clonex_css',true) + '</div>'
    + '<div class="gtc-rsec"><div class="gtc-rslbl">🧬 Add AZOS For Explosive Root Growth</div>'
    + '<div class="gtc-pc ess" style="border:2px solid #00a846;background:#f0faf3">'
    + '<div class="gtc-pem">🧬</div>'
    + '<div class="gtc-pi"><div class="gtc-pn">AZOS — Nitrogen Fixing Bacteria (56g)</div>'
    + '<div class="gtc-pw"><strong>What AZOS actually does:</strong> Living bacteria that pulls nitrogen from the air and colonises your roots. Dramatically speeds up root development on cuttings. Dust the cut end before dipping in Clonex. The backbone of the Brown Formula.</div>'
    + '<button class="gtc-atc" data-handle="azos-nitrogen-fixing-bacteria">+ Add to Cart</button></div>'
    + '<div class="gtc-pr">$52.00</div><span class="gtc-bdg essential">ESSENTIAL</span></div></div>'
    + '<div class="gtc-rsec"><div class="gtc-rslbl">⚠️ Environment Matters</div>'
    + '<div style="background:#fff3b0;border:1.5px solid #ffd600;border-radius:8px;padding:10px 12px;margin-bottom:8px;font-size:11px;color:#4a6650;line-height:1.6">🌡️ <strong>Air:</strong> 22–26°C &nbsp;|&nbsp; 💧 <strong>Water/media:</strong> 20–24°C &nbsp;|&nbsp; 💦 <strong>Humidity:</strong> 70–90%</div>'
    + gtcPCard('cultiv8_hygro',true) + '</div>'
    + '<div class="gtc-rsec"><div class="gtc-rslbl">🔪 Clean Cuts = Better Strike Rate</div>'
    + gtcPCard('scalpel',true) + gtcPCard('loupe_40x',false) + '</div>'
    + '<div class="gtc-rsec"><div class="gtc-rslbl">🌱 Choose Your Propagation Method</div>'
    + '<div style="background:#fff;border:1.5px solid #ddeee2;border-radius:8px;padding:10px 12px;margin-bottom:5px"><strong style="font-size:11px">🔺 Eazy Plugs — Beginner Friendly ($16.50 for 24)</strong><div style="font-size:10px;color:#4a6650;line-height:1.5;margin-top:2px">Organic plugs, self-regulate moisture, impossible to overwater.</div></div>'
    + '<div style="background:#fff;border:1.5px solid #ddeee2;border-radius:8px;padding:10px 12px;margin-bottom:5px"><strong style="font-size:11px">🧱 Rockwool Cubes — Classic ($0.44 each)</strong><div style="font-size:10px;color:#4a6650;line-height:1.5;margin-top:2px">Soak in pH adjusted water, insert cutting. 7-14 days to roots.</div></div>'
    + '<div style="background:#fff;border:1.5px solid #ddeee2;border-radius:8px;padding:10px 12px;margin-bottom:5px"><strong style="font-size:11px">🥥 Coco Plugs ($9.90 for 50)</strong><div style="font-size:10px;color:#4a6650;line-height:1.5;margin-top:2px">Straight into final pot when roots appear — no transplant shock.</div></div>'
    + '<div style="background:#fff3b0;border:1.5px solid #ffd600;border-radius:8px;padding:10px 12px;margin-bottom:5px"><strong style="font-size:11px">🚀 Sea-Hawk Aero Cloner — Fastest ($120+)</strong><div style="font-size:10px;color:#4a6650;line-height:1.5;margin-top:2px">Aeroponic cloner mists roots 24/7. Roots in 5-7 days.</div></div>'
    + '</div>';
}

function gtcShowResults() {
  /* validate pH if required */
  var hasSilica = GTC.silica === 'yes';
  var isProp    = GTC.goal === 'propagate' || GTC.goal === 'both';
  var needsPh   = hasSilica || GTC.method === 'coco' || GTC.method === 'leca' || isProp;
  if (needsPh && !GTC.ph) {
    var phOpts = document.querySelector('#gtc-ph-req .gtc-opts') || document.getElementById('gtc-ph-req');
    gtcShake(phOpts);
    var hint5 = document.getElementById('gtc-hint5'); if (hint5) hint5.classList.add('show');
    return;
  }

  var ps5=document.getElementById('gtcps5'); if(ps5) ps5.className='gtc-step done';
  var ps6=document.getElementById('gtcps6'); if(ps6) ps6.className='gtc-step active';
  var s5=document.getElementById('gtcs5');  if(s5)  s5.classList.remove('active');
  var s6=document.getElementById('gtcs6');  if(s6)  s6.classList.add('active');

  var plant  = GTC_PLANTS.find(function(p){return p.v===GTC.plant;});
  var fKey   = plant ? plant.f : 'foliage_focus';
  var isCoco = GTC.method==='coco', isLeca=GTC.method==='leca';
  var sections = [];

  var nutr = isCoco ? ['coco_grow'] : [fKey];
  if (GTC.silica==='yes') nutr.push('silica');
  if (isCoco||isLeca) nutr.push('calmag');
  sections.push({t:'🌿 Nutrients', items:nutr});

  if (GTC.goal==='grow'||GTC.goal==='both')
    sections.push({t:'🧬 Root Builders', items:['azos','mykos']});

  if (GTC.goal==='propagate'||GTC.goal==='both')
    sections.push({t:'PROP', items:['clonex_gel','clonex_css','rootzone','azos','cultiv8_hygro','scalpel'], prop:true});

  if (GTC.media.length) sections.push({t:'🪴 Growing Media', items:GTC.media});

  var ph = GTC.ph || (needsPh ? 'budget' : null);
  if (ph==='budget')  sections.push({t:'💧 pH Management', items:['ph_kit'],        ph:true});
  if (ph==='digital') sections.push({t:'🟡 pH Management', items:['ph_pen_bundle'], ph:true});

  var total=0;
  sections.forEach(function(sec){sec.items.forEach(function(k){total+=(GTC_P[k]||{}).p||0;});});
  var pm=total*0.8, saving=total*0.2;
  var mLbl={soil:'Soil',coco:'Coco',leca:'LECA / Semi-Hydro'};

  var html='<div class="gtc-rhero"><div class="gtc-pill">🌿 Your Kit Is Ready</div>'
    +'<h2>Your GT Grow Kit</h2>'
    +'<p>'+(plant?plant.l:'Your plants')+' · '+(mLbl[GTC.method]||'')+' · '
    +(GTC.goal==='both'?'Grow & Propagate':GTC.goal==='propagate'?'Propagation':'Growing')
    +'</p></div>';

  sections.forEach(function(sec){
    if(sec.prop){html+=gtcBuildPropSection();return;}
    html+='<div class="gtc-rsec"><div class="gtc-rslbl">'+sec.t+'</div>';
    sec.items.forEach(function(k){
      var p=GTC_P[k];if(!p)return;
      var cls=sec.ph?'gtc-pc phc':'gtc-pc ess';
      var bdg=sec.ph?'ph':p.b;
      var atc=p.h?'<button class="gtc-atc" data-handle="'+p.h+'">+ Add to Cart</button>':'';
      html+='<div class="'+cls+'"><div class="gtc-pem">'+p.e+'</div>'
        +'<div class="gtc-pi"><div class="gtc-pn">'+p.n+'</div><div class="gtc-pw">'+p.w+'</div>'+atc+'</div>'
        +'<div class="gtc-pr">$'+p.p.toFixed(2)+'</div>'
        +'<span class="gtc-bdg '+bdg+'">'+bdg.toUpperCase()+'</span></div>';
    });
    html+='</div>';
  });

  html+='<div class="gtc-tots">'
    +'<div class="gtc-tr"><span>Retail total</span><span>$'+total.toFixed(2)+'</span></div>'
    +'<div class="gtc-tr save"><span>🌿 PM Rewards — 20% off</span><span>−$'+saving.toFixed(2)+'</span></div>'
    +'<div class="gtc-tr grand"><span>YOUR PRICE</span><span class="v">$'+pm.toFixed(2)+'</span></div>'
    +'</div>';

  var allKeys=[];
  sections.forEach(function(sec){sec.items.forEach(function(k){if(GTC_P[k]&&GTC_P[k].h)allKeys.push(k);});});
  if(allKeys.length){
    html+='<div style="text-align:center;margin:14px 0">'
      +'<button class="gtc-addall" id="gtc-add-all" data-keys=\''+JSON.stringify(allKeys)+'\'>🛒 Add Full Kit to Cart</button>'
      +'<div style="font-size:10px;color:#8aa890;margin-top:5px">Adds all '+allKeys.length+' products at once</div></div>';
  }

  html+='<div class="gtc-rb"><div class="gtc-rbi">🌿</div><div class="gtc-rbb">'
    +'<h3>Save $'+saving.toFixed(2)+' with PM Rewards</h3>'
    +'<p>20% off every order. Founding member pricing locked forever.</p>'
    +'</div></div>'
    +'<div class="gtc-ctas">'
    +'<a href="/pages/pm-rewards" class="gtc-btn">Join PM Rewards →</a>'
    +'<button class="gtc-ghost" data-reset="1">Start Again</button>'
    +'</div>';

  var el=document.getElementById('gtc-results');
  if(el) el.innerHTML=html;
  var panel=document.getElementById('pmCalcInner');if(panel)panel.scrollTop=0;
}

async function gtcAddToCart(handle,btn){
  if(btn){btn.textContent='...';btn.disabled=true;}
  try{
    var res=await fetch('/products/'+handle+'.js');
    var prod=await res.json();
    await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:prod.variants[0].id,quantity:1})});
    if(btn){btn.textContent='✓ Added';btn.classList.add('done');btn.disabled=false;}
    return true;
  }catch(e){
    if(btn){btn.textContent='Error';btn.disabled=false;}
    return false;
  }
}

async function gtcAddAll(keys){
  var btn=document.getElementById('gtc-add-all');
  if(btn){btn.textContent='Adding...';btn.disabled=true;}
  var added=0;
  for(var i=0;i<keys.length;i++){var p=GTC_P[keys[i]];if(p&&p.h){var ok=await gtcAddToCart(p.h,null);if(ok)added++;}}
  if(btn){btn.textContent=added+' items added! View Cart →';btn.style.background='#00a846';btn.dataset.cart='1';btn.disabled=false;}
}

function gtcReset(){
  GTC.goal=null;GTC.method=null;GTC.plant=null;GTC.silica=null;GTC.ph=null;GTC.media=[];
  gtcCur=1;
  var c=document.getElementById('pmCalcInner');if(!c)return;
  c.querySelectorAll('.gtc-sec').forEach(function(s){s.classList.remove('active');});
  c.querySelectorAll('.gtc-opt').forEach(function(o){o.classList.remove('selected');});
  c.querySelectorAll('.gtc-tog').forEach(function(b){b.classList.remove('on');});
  c.querySelectorAll('.gtc-step').forEach(function(s){s.className='gtc-step';});
  c.querySelectorAll('.gtc-hint').forEach(function(h){h.classList.remove('show');});
  var s1=document.getElementById('gtcs1');if(s1)s1.classList.add('active');
  var ps1=document.getElementById('gtcps1');if(ps1)ps1.className='gtc-step active';
  var res=document.getElementById('gtc-results');if(res)res.innerHTML='';
  c.scrollTop=0;
}